import React, { useState } from "react";
import SubItem from "./SubItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinus,
  faPlus,
  faCheck,
  faAngleDown,
  faAngleUp,
} from "@fortawesome/free-solid-svg-icons";
export default function AnotherItem({ item, selected, setSelected, getProductReq }) {
  return (
    <>
      <div
        onClick={() => {
          if (selected.includes(item.key)) {
            setSelected(selected.filter((x) => x != item.key));
          } else {
            setSelected([...selected, item.key]);
          }
          setTimeout(() => {
            getProductReq();
          }, 200);
        }}
        className={"category-sub-item "}
      >
        <span
          style={{ marginLeft:-40 }}
          className={
            "check-box " + (selected.includes(item.key) ? "checked" : "")
          }
        >
          <span>
            <FontAwesomeIcon icon={faCheck} />
          </span>
        </span>
        <div className="name">
          <span>{item.name}</span>
          {/* <span style={{ fontSize: 12 }}></span> */}
        </div>
      </div>
    </>
  );
}
